const APPConstants = require('../Constants/AppConstants');

module.exports = {
  URLPaths: {
    BaseURL: APPConstants.BaseURL,
    sandboxBaseURL: 'https://api.sandbox.tradly.app/',
    productionBaseURL: 'https://api.tradly.app/',
    skuaURL: 'https://skua.tradly.app/',
    clients: 'skua/tenants/users_tenants', //TODO
    domains: 'skua/tenants/domains',
    refreshToken: 'v1/users/token/refresh',
    createTenant: 'skua/tenants/', //TODO
    sampleData: 'v1/tenants/sample_data',
    countryURl: 'v1/countries',
    currencies: 'v1/currencies',
    currencyRates: 'v1/currencies/rates',
    developerAPIKey: 'skua/tenants/',
    mcpCredentials: 'skua/oauth/credentials',
    mcpRegisterClient: 'skua/oauth/register-client',
    config: 'v1/configs',
    config_list_group: '/v1/configs/list_grouped',
    whatsappEmbeddedSignupConfig: 'v1/integrations/whatsapp/embedded-signup/config',
    whatsappEmbeddedSignupExchange: 'v1/integrations/whatsapp/embedded-signup/exchange',
    whatsappConnections: 'v1/integrations/whatsapp/connections',
    whatsappConnectionDefault: 'v1/integrations/whatsapp/connections/{id}/default',
    whatsappTemplateCatalog: 'v1/integrations/whatsapp/templates/catalog',
    whatsappTemplates: 'v1/integrations/whatsapp/templates',
    whatsappApprovedTemplates: 'v1/integrations/whatsapp/templates/approved',
    whatsappTestMessage: 'v1/integrations/whatsapp/templates/test-message',
    whatsappTemplateSubmit: 'v1/integrations/whatsapp/templates/submit',
    S3signedUploadURL: 'v1/utils/S3signedUploadURL',
    logout: 'v1/users/logout',
    paymentMethod: 'v1/payments/methods',
    stripeConnectOAuth: 'v1/payments/stripe/connect/oauth',
    tenantPaymentMethod: 'v1/tenants/payment_methods',
    tenantAnalytics: 'v1/tenants/analytics',
    shippingMethod: 'v1/shipping_methods',
    tenantShippingMethod: 'v1/tenants/shipping_methods',
    commissions: 'v1/commissions?type=',
    addCommissions: 'v1/commissions',
    categories: 'v1/categories?parent=0&type=',
    listing_search: '/v1/listings/search/phrases',
    addCategories: 'v1/categories',
    collections: 'v1/collections',
    accountListings: 'v1/accounts?page=',
    listings: 'v1/listings?page=',
    listingsModerate: 'v1/listings',
    promo: 'v1/promos',
    transactions: 'v1/transactions?page=',
    attributes: 'v1/attributes',
    attributes_group: 'v1/attribute_groups',
    accounts: 'v1/accounts/',
    ordersList: 'v1/orders?page=',
    order: 'v1/orders/',
    orderCashRefund: 'v1/orders',
    user: 'v1/users',
    copilot: '/v1/ai_services',
    aiReports: '/v1/ai_reports',
    authAttempts: 'v1/auth_attempts',
    mapsUsage: 'v1/maps/usage',
    mapsGeocode: 'v1/maps/geocode',
    mapsMarketAnalysis: 'v1/maps/market-analysis',
    inventoryStock: 'v1/inventory/stock',
    inventoryLocations: 'v1/inventory/locations',
    purchaseOrders: 'v1/inventory/purchase-orders',
    suppliers: 'v1/suppliers',
    expenses: 'v1/expenses',
    expenseSummary: 'v1/expenses/summary',
    expenseCategories: 'v1/expenses/categories',
    recurringPayments: 'v1/recurring-payments',
    automationRules: 'automation-rules',
    automationRuleActions: 'automation-rules/actions',
    hrDepartments: 'v1/staff/departments',
    hrJobProfiles: 'v1/staff/job-profiles',
    hrPayGrades: 'v1/staff/pay-grades',
    hrStaff: 'v1/staff',
    hrShifts: 'v1/staff/shifts',
    hrAttendance: 'v1/staff/attendance',
    hrLeavePolicies: 'v1/staff/leave-policies',
    hrLeaveBalances: 'v1/staff/leave-balances',
    hrLeaveRequests: 'v1/staff/leave-requests',
    hrPayrollRuns: 'v1/staff/payroll-runs',
    hrPayComponents: 'v1/staff/pay-components',
    hrExpenseCategories: 'v1/expenses/categories',
    hrExpenseClaims: 'v1/expenses',
    enterpriseSsoSettings: 'skua/users/enterprise_sso/settings',
    enterpriseSsoTest: 'skua/users/enterprise_sso/test',
    //     paymentMethods: 'v1/tenants/payment_methods',
    shippingMethods: 'v1/shipping_methods',
    language: 'v1/languages',
    tanantslanguage: 'v1/tenants/languages',
    appTranslationGroup: 'v1/client_translations/groups',
    appTranslationValue: 'v1/client_translations/values?group=',
    addAppTranslations: 'v1/client_translations/',
    addVariant: 'v1/variant_types',
    appCountry: 'v1/tenants/countries',
    translations: 'v1/translations',
    addresses: 'v1/addresses',
    chart: 'v1/admin/home',
    reviews: 'v1/reviews',
    bulk: '/bulk',
    inviteMember: 'skua/sub_users',
    media: 'v1/media',
    configsTranslations: 'v1/configs/translations',
    userRole: 'skua/user_roles',
    skuaUser: 'skua/users/detail',
    schedules: 'schedules',
    taxes: 'v1/taxes',
    tax: 'v1/taxes',
    coupons: 'v1/coupons',
    subscriptionsPlans: 'skua/subscriptions/plans',
    upgradeMoment: 'skua/subscriptions/upgrade_moment',
    planClick: 'skua/subscriptions/plan_click',
    onboardingEvents: 'skua/onboarding/events',
    subscriptionPlanFeatures: 'skua/subscriptions/plan_features',
    usageSummary: 'skua/usage/summary',
    usageEvents: 'v1/usage/events',
    usageHistory: 'paas/v1/usage/history',
    mediaUsageSummary: 'paas/v1/usage/summary',
    aiCreditsBalance: 'skua/ai/balance',
    aiCreditsSummary: 'skua/ai/credits/summary',
    usersExport: 'v1/users/export',
    categoriesExport: 'v1/categories/export',
    accountsExport: 'v1/accounts/export',
    importListings: 'v1/listings/import',
    exportListings: 'v1/listings/export',
    coupons: 'v1/coupons',
    addons: 'v1/addons',
    testEmail: 'v1/utils/email',
    clientTranslationValuesGroupedByLanguage:
      'v1/client_translations/values_grouped_by_languages?',
    updateAppTranslations: 'v1/client_translations/bulk',
    S3SignedGetURL: '/v1/utils/S3signedGetURL',
    group_configs_list: '/v1/configs/list_grouped?key_group=',
    reportedListings: 'v1/listings/reported/list',
    reportedAccounts: 'v1/accounts/reported/list',
    // Cart endpoints use the standard v1 namespace. The products namespace
    // is for listings/orders and returns 404 for cart checkout requests.
    cart: 'v1/cart',
    checkout: 'v1/cart/checkout',
    applyCoupon: 'v1/cart/coupon',
    // SES email identity verification
    sesIdentityStatus: 'v1/tenants/ses/identities/status',
    sesIdentities: 'v1/tenants/ses/identities',

    /*  Delivery End points */
    deliveryOrder: 'delivery/v1/orders/',
    deliveryBranches: 'delivery/v1/branches/',
    deliveryFleets: 'delivery/v1/fleets/',
    deliveryDriver: 'delivery/v1/users/',
    delivertRegisterDriver: 'register/driver',
    deliveryCountry: 'delivery/v1/tenants/countries/',
    deliveryUnassignBranch: 'driver/unassign_branch',
    deliveryUnassignFleet: 'driver/unassign_fleet',
    deliveryResetPassword: 'delivery/v1/users/password/reset',
    deliveryAuditLog: 'delivery/v1/audit_logs',
    complianceAuditLogs: 'v1/audit-logs',
    deliveryRoster: 'delivery/v1/rosters',
    deliveryReport: 'delivery/v1/reports',
    deliveryDriverCredit: 'delivery/v1/driver_credits',
    deliveryDriverDashboard: 'delivery/v1/dashboard/counts',
    deliveryDriverDashboardOrderCount: 'delivery/v1/dashboard/order_counts',
    activateTenant: 'skua/tenants/activate_product',
    subscription: 'v1/subscription_products',
    extension: 'v1/extensions',
    layers: 'v1/layers',
  },
};
